/* ============
 * Mutation types for the Project module
 * ============
 *
 * The mutation types that are available
 * on the project module.
 */

export const LOAD = 'LOAD';
export const SEND_QUESTION = 'SEND_QUESTION';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';

export default {
  LOAD,
  SEND_QUESTION,
  LOAD_TRANSLATIONS,
};
